module.exports = __webpack_public_path__ + "img/media-items.dcda53e3.svg";